import { render, staticRenderFns } from "./InfoIcons.vue?vue&type=template&id=d9cbf98e"
import script from "./InfoIcons.vue?vue&type=script&lang=js"
export * from "./InfoIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports